import script from "./resultPopup.vue?vue&type=script&setup=true&lang=js"
export * from "./resultPopup.vue?vue&type=script&setup=true&lang=js"

import "./resultPopup.vue?vue&type=style&index=0&id=a7cc71a4&lang=less"

const __exports__ = script;

export default __exports__